import { useState, type ReactElement } from 'react';
import { TextArea, type TextAreaProps } from '../Field/Field';
import { Markdown } from './Markdown';
import styles from './MarkdownField.module.scss';

export type MarkdownFieldProps = TextAreaProps & {
  /** Подпись раскрывающегося предпросмотра. */
  previewLabel: string;
  /** Что показать в предпросмотре пустого текста. */
  emptyPreview: string;
};

/**
 * Многострочное поле с текстом в Markdown и предпросмотром под ним. Разборщик грузится, только
 * когда предпросмотр открыт.
 */
export function MarkdownField({ previewLabel, emptyPreview, ...textarea }: MarkdownFieldProps): ReactElement {
  const [open, setOpen] = useState(false);
  const text = typeof textarea.value === 'string' ? textarea.value : '';
  return (
    <div className={styles.field}>
      <TextArea {...textarea} />
      <details className={styles.preview} onToggle={(event) => setOpen(event.currentTarget.open)}>
        <summary className={styles.summary}>{previewLabel}</summary>
        {open ? (
          <div className={styles.body}>
            <Markdown text={text} empty={emptyPreview} />
          </div>
        ) : null}
      </details>
    </div>
  );
}
